import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import documentoApi from '../../api/documentoApi';
import contribuenteApi from '../../api/contribuenteApi';
import { useParams, useNavigate } from 'react-router-dom';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { Switch, FormControlLabel } from '@mui/material';
const DOCUMENT_TYPES = [
   'DOCUMENTO_IDENTITA',
   'CONTRATTO',
   'UNICO',
   'MULTA',
   'PAGOPA',
   'ATTO_SOCIETARIO',
   'BANCARIO',
   'RATEIZZAZIONE_ADE',
   'ROTTAMAZIONE',
   'AMA',
   'F24',
   'ALTRO'
];
export default function DocumentoEditPage() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [contribuenti, setContribuenti] = useState([]);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    documentoApi.get(id).then(r => setForm(r.data));
    contribuenteApi.list({ page: 0, size: 100 }).then(r => setContribuenti(r.data.content || []));
  }, [id]);

  if (!form) return <div>Loading...</div>;

  const submit = async (e) => {
    e.preventDefault();
    try {
      await documentoApi.update(id, form);
      navigate(`/documenti/${id}`);
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h5">Modifica Documento</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}
      <form onSubmit={submit}>
        <TextField
          select
          fullWidth
          sx={{ my: 1 }}
          label="Tipo"
          value={form.tipo}
          onChange={e => setForm({ ...form, tipo: e.target.value })}
          required
        >
          {DOCUMENT_TYPES.map(t => (
            <MenuItem key={t} value={t}>
              {t}
            </MenuItem>
          ))}
        </TextField>
        <TextField fullWidth sx={{ my: 1 }} label="Descrizione" value={form.descrizione} onChange={e => setForm({...form, descrizione: e.target.value})} />
        <FormControlLabel
          control={
            <Switch
              checked={form.decaduta || false}
              onChange={e => setForm({ ...form, decaduta: e.target.checked })}
            />
          }
          label="Documento decaduto"
        />

        <TextField select fullWidth sx={{ my: 1 }} label="Contribuente" value={form.contribuenteId} onChange={e => setForm({...form, contribuenteId: e.target.value})}>
          {contribuenti.map(c => <MenuItem key={c.id} value={c.id}>{c.nome} {c.cognome}</MenuItem>)}
        </TextField>
        <Button variant="contained" type="submit">Salva</Button>
      </form>
    </Container>
  );
}